export default "__VITE_ASSET__0f5f8679__"